// @safetyhub/report-composer — Special 위젯 placeholder (3종)
//
// annotatedPhoto / signaturePad / approvalBlock.
// Phase 1에서는 placeholder만 렌더. 실제 web 컴포넌트 래핑은 후속 범위.

import type { CSSProperties } from 'react';
import type { SpecialNode } from '@safetyhub/shared';
import { nodeLayoutToStyle, type ParentContext } from './layout';

export function SpecialPrim({ node, parent }: { node: SpecialNode; value?: unknown; parent?: ParentContext }) {
  const style: CSSProperties = { ...nodeLayoutToStyle(node.layout, parent) };
  // TODO(후속): 기존 web 컴포넌트(PhotoFindings/SignaturePad/ApprovalStatus) 래핑
  return (
    <div data-composer-node-id={node.id} data-special={node.special} style={style}>
      [{node.special}]
    </div>
  );
}
